import axios from "axios";
import { getToken } from "../../Utlis/UpdateUserState";

const getFleetManagerDashboard = async (period) => {
  try {
    const token = getToken();

    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}fleet-manager/dashboard/`,
      {
        headers: { Authorization: `Bearer ${token}` },
        params: period ? { period } : undefined,
      },
    );

    return res;
  } catch (error) {
    console.error("Fleet manager dashboard fetch error:", error);
    throw error;
  }
};

export { getFleetManagerDashboard };
